import i18n from "~/i18n/i18n";

interface CustomerNode {
	customerName?: unknown;
	name?: unknown;
}

interface QueryEntry {
	data?: unknown;
	endpointName?: string;
}

const ORDER_ENDPOINTS = new Set(["GetOrders"]);
const CUSTOMER_ENDPOINTS = new Set(["GetCustomers", "GetCustomersPaginated"]);

const buildGenericSuggestions = (): string[] => [
	i18n.t("fernieChat.suggestions.openOrders", { ns: "common" }),
	i18n.t("fernieChat.suggestions.customers", { ns: "common" }),
	i18n.t("fernieChat.suggestions.catalogItems", { ns: "common" }),
	i18n.t("fernieChat.suggestions.priceGroups", { ns: "common" }),
	i18n.t("fernieChat.suggestions.summaryReport", { ns: "common" })
];

const asName = (value: unknown): string | undefined =>
	typeof value === "string" && value.trim() ? value.trim() : undefined;

const readNodes = (data: unknown, collection: string): CustomerNode[] => {
	if (!data || typeof data !== "object") return [];
	const wrapper = (data as Record<string, unknown>)[collection];
	if (!wrapper || typeof wrapper !== "object") return [];
	const nodes = (wrapper as Record<string, unknown>).nodes;
	return Array.isArray(nodes) ? (nodes as CustomerNode[]) : [];
};

export const resolveWelcomeCustomerName = (apiSliceState: unknown): string | undefined => {
	const state = apiSliceState as { queries?: Record<string, QueryEntry | undefined> } | undefined;
	const queries = state?.queries ?? {};
	let customerFallback: string | undefined;
	for (const entry of Object.values(queries)) {
		const endpoint = entry?.endpointName;
		if (!endpoint) continue;
		if (ORDER_ENDPOINTS.has(endpoint)) {
			for (const node of readNodes(entry?.data, "orders")) {
				const name = asName(node.customerName);
				if (name) return name;
			}
		} else if (!customerFallback && CUSTOMER_ENDPOINTS.has(endpoint)) {
			for (const node of readNodes(entry?.data, "customers")) {
				const name = asName(node.name);
				if (name) {
					customerFallback = name;
					break;
				}
			}
		}
	}
	return customerFallback;
};

export const buildWelcomeSuggestions = (customerName?: string): string[] => {
	const name = customerName?.trim();
	if (!name) return buildGenericSuggestions();
	return [
		i18n.t("fernieChat.suggestions.createOrderFor", { name, ns: "common" }),
		i18n.t("fernieChat.suggestions.recentOrdersOf", { name, ns: "common" }),
		...buildGenericSuggestions()
	];
};

export default buildWelcomeSuggestions;
